import React, {useState} from 'react';
import { useForm, Controller } from "react-hook-form";
import OtpInput from 'react-otp-input';
import {
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  DialogTitle,
  DialogContentText,
  DialogContent,
  Dialog,
  IconButton
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import Timer from 'pages/otp/Timer';

export default function OtpDialog(props) {
  
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const mobile =  '(+91) 987654321'
  const [errorOtp, setErrorOtp] = useState('')

  const handleClose = () => {
    props.handleClose();
  };

  const onSubmit = (data) => {
    // Handle form submission
    props.onSubmittBtn();
  };
  const handleOtpChange = (value) => {
    const validateNumber = Number(value) ? true : false
    if(!validateNumber){
      setErrorOtp('OTP must contain only numbers')
    }else if(value.length === 4 && validateNumber ){
      onSubmit(value)
    }else{
      setErrorOtp('')
    }
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Grid container>
            <Grid item xs={12} className="dialogHead">
              <Typography className='titleStyle'>Enter Your <span className='colorSecondary'>OTP</span></Typography>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container>
              <Grid item xs={12} className='formPadding'>
                <div>
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item sm={8} sx={{ textAlign: 'center' }} className="">
                      <div className="col-12 text-center">
                        <p className="colorGrey font16 fontNormal ">
                          An authentication otp has been sent to
                        </p>
                        <p className="colorGrey font16 fontSemi marginBottom35">{mobile}</p>
                      </div>
                    </Grid>

                    <form onSubmit={handleSubmit(onSubmit)}>
                      {/* ---OTP UI--- */}
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                      >
                        <Grid item sm={8} className="">
                          <Controller
                            name="otp"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: 'OTP is required',
                              minLength: {
                                value: 4,
                                message: 'OTP must be 4 characters long',
                              }
                            }}
                            render={({ field }) => (
                              <OtpInput
                                containerStyle="otp"
                                inputStyle={
                                  errors.otp ? 'otpStyleError' : 'otpStyle'
                                }
                                value={field.value}
                                onChange={(value) => {
                                  field.onChange(value);
                                  handleOtpChange(value);
                                }}
                                numInputs={4}
                                renderInput={(props) => <input {...props} />}
                              />
                            )}
                          />
                          {errorOtp && (
                            <p className="errorOtp">
                              <span>
                                <ErrorIcon />
                              </span>
                              {errorOtp}
                            </p>
                          )}
                        </Grid>
                        <Grid container item sm={8} justifyContent="center">
                          {/* ---Timer Screen--- */}
                          <Grid item>
                            <div>
                              <Timer />
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </form>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}